import {
  Button,
  Dialog,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Text,
} from "@fluentui/react-components";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { useCustomDialogStyles } from "./CustomDialog.styles";
import { ICustomDialogProps } from "./CustomDialog.types";

export const CustomDialog = (props: ICustomDialogProps) => {
  const styles = useCustomDialogStyles();

  return (
    <Dialog
      open={props.isOpen}
      onOpenChange={(event, data) => !data.open && props.onClose()}
    >
      <DialogSurface className={styles.dialogSurface}>
        <Button
          icon={<Dismiss20Regular />}
          appearance="subtle"
          className={styles.dismissButton}
          onClick={props.onClose}
        />

        {props.title && (
          <DialogTitle className={styles.dialogTitle}>
            <Text size={400} weight="semibold">
              {props.title}
            </Text>
          </DialogTitle>
        )}

        <DialogContent>{props.children}</DialogContent>
      </DialogSurface>
    </Dialog>
  );
};
